import { render, staticRenderFns } from "./purchase-item-delivery.vue?vue&type=template&id=845917c4&"
import script from "./purchase-item-delivery.vue?vue&type=script&lang=js&"
export * from "./purchase-item-delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports